import { UserAgent } from '.';
import * as marietta from '../..';
import { EventDispatcher } from '../flash/events';

/*
 * Stageクラス
 * 主にMouseMoveイベントを制御
 */
export default class Stage extends EventDispatcher {
  private static _instance: Stage;

  private _mouseX: number;

  private _mouseY: number;

  private _offsetX: number;

  private _offsetY: number;

  constructor() {
    super();

    this._mouseX = 0;
    this._mouseY = 0;

    if (UserAgent.isMobile) {
      window.addEventListener('touchstart', (e:TouchEvent) => {
        this.moveMobileHandler(e);
      });
      window.addEventListener('touchmove', (e:TouchEvent) => {
        this.moveMobileHandler(e);
      });
    } else {
      window.addEventListener('mousemove', (e:MouseEvent) => {
        this.movePcHandler(e);
      });

      const capture:HTMLElement = document.querySelector('.stageMouseCapture');

      if (capture) {
        capture.addEventListener('mousedown', (e:MouseEvent) => {
          e.preventDefault();
          this.dispatchEvent(new MouseEvent(marietta.webcad.flash.events.MouseEvent.MOUSE_DOWN));
        });
        capture.addEventListener('mouseup', (e:MouseEvent) => {
          e.preventDefault();
          this.dispatchEvent(new MouseEvent(marietta.webcad.flash.events.MouseEvent.MOUSE_UP));
        });
        capture.addEventListener('click', (e:MouseEvent) => {
          e.preventDefault();
          this.dispatchEvent(new MouseEvent(marietta.webcad.flash.events.MouseEvent.CLICK));
        });
      }
    }
  }

  private movePcHandler(e: MouseEvent): void {
    // e.preventDefault();

    this._mouseX = e.pageX;
    this._mouseY = e.pageY;

    // $('.mouseX').val(this._mouseX);
    // $('.mouseY').val(this._mouseY);
  }

  private moveMobileHandler(e: TouchEvent): void {
    this._mouseX = e.touches[0].pageX;
    this._mouseY = e.touches[0].pageY;
  }

  /*
   *
   */
  public static initialize(): void {
    if (Stage._instance == null) {
      Stage._instance = new Stage();
    }
  }

  /*
   * タブレットの場合、mousemoveが監視できないため、
   * 他のオブジェクトイベントでtouchstartが走った際に、
   * StageのmouseX/mouseYを更新するようにする。
   */
  public static refreshStageMouse(e: TouchEvent): void {
    Stage.updateMouse(e);
  }

  private static updateMouse(e: TouchEvent): void {
    Stage._instance._mouseX = e.touches[0].pageX;
    Stage._instance._mouseY = e.touches[0].pageY;
  }

  public static set offsetX(value: number) {
    Stage._instance._offsetX = value;
  }

  public static get offsetX(): number {
    return Stage._instance._offsetX;
  }

  public static set offsetY(value: number) {
    Stage._instance._offsetY = value;
  }

  public static get offsetY(): number {
    return Stage._instance._offsetY;
  }

  public static get mouseX(): number {
    return Stage._instance._mouseX;
  }

  public static get mouseY(): number {
    return Stage._instance._mouseY;
  }

  public static addEventListener(type: string, func: Function): void {
    Stage._instance.addEventListener(type, func);
  }

  public static removeEventListener(type: string, func: Function): void {
    Stage._instance.removeEventListener(type, func);
  }

  public static removeAllEventListener(): void {
    Stage._instance.removeAllEventListener();
  }
}
